import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Context from '../context'
import displayINRCurrency from '../helpers/displayCurrency'
import { MdClose } from "react-icons/md";
import { FaHeart, FaShoppingBag, FaTrash, FaPlus, FaMinus } from "react-icons/fa"
import { useSelector } from 'react-redux'
import HorizontalCardProduct from '../components/HorizontalCardProduct'
import addToCart from '../helpers/addToCart'
import wishlistHelper from '../helpers/wishlistHelper'
import SummaryApi from '../common'

const Wishlist = () => {
 const { wishlistItems, fetchUserWishlist, fetchUserAddToCart, cartItems, setShowCart } = useContext(Context)
 const user = useSelector(state => state?.user?.user)
 const navigate = useNavigate()
 const [loading, setLoading] = useState(false)

 useEffect(() => {
 fetchUserWishlist()
 }, [fetchUserWishlist])

 const removeFromWishlist = (e, id) => {
 wishlistHelper.addToWishlist(e, { _id: id })
 fetchUserWishlist()
 }

 const handleAddToCart = async (e, id) => {
 const userId = user?._id || user?.id;
 if (!userId) {
 navigate("/login");
 return;
 }
 await addToCart(e, id, userId)
 fetchUserAddToCart()
 }

 const updateQty = async (e, id, qty, isDummy, dummyId, change) => {
 e?.stopPropagation()
 e?.preventDefault()

 if (isDummy) {
 let cart = JSON.parse(localStorage.getItem('dummyCart')) || []
 const item = cart.find(i => i.productId === dummyId)
 if (item) {
 if (change === -1 && item.quantity === 1) {
 cart = cart.filter(i => i.productId !== dummyId)
 } else {
 item.quantity += change
 }
 localStorage.setItem('dummyCart', JSON.stringify(cart))
 fetchUserAddToCart()
 }
 return
 }

 const newQty = qty + change
 if (newQty === 0) {
 const response = await fetch(SummaryApi.deleteCartProduct.url, {
 method: SummaryApi.deleteCartProduct.method,
 credentials: 'include',
 headers: { "content-type": 'application/json' },
 body: JSON.stringify({ _id: id })
 })
 const responseData = await response.json()
 if (responseData.success) { fetchUserAddToCart() }
 } else {
 const response = await fetch(SummaryApi.updateCartProduct.url, {
 method: SummaryApi.updateCartProduct.method,
 credentials: 'include',
 headers: { "content-type": 'application/json' },
 body: JSON.stringify({ _id: id, quantity: newQty })
 })
 const responseData = await response.json()
 if (responseData.success) { fetchUserAddToCart() }
 }
 }

 if (wishlistItems.length === 0 && !loading) {
 return (
 <div className='min-h-screen bg-[#f4f7f5] flex flex-col'>
 <div className='flex-1 flex flex-col items-center justify-center p-6 text-center'>
 <div className='w-full max-w-sm mb-12 animate-float'>
 <img
 src="https://img.freepik.com/free-vector/no-data-concept-illustration_114360-616.jpg"
 alt="Empty Wishlist"
 className='w-full h-auto opacity-90 mix-blend-multiply'
 />
 </div>

 <h2 className='text-3xl font-black text-[#143d2c] mb-4'>No Products Added to Wishlist</h2>
 <p className='text-gray-400 text-lg mb-10 max-w-md mx-auto leading-relaxed'>
 Looks like you haven't added anything to your wishlist yet. Explore our fresh architectural products.
 </p>

 <button
 className='bg-[#2d8a5a] hover:bg-[#143d2c] text-white font-bold py-5 px-14 rounded-2xl shadow-xl transition-all active:scale-95 text-lg uppercase tracking-widest'
 onClick={() => navigate("/")}
 >
 Continue Shopping
 </button>
 </div>

 <div className='w-full py-12 bg-white border-t border-gray-100'>
 <HorizontalCardProduct category="Seeds" heading="Fresh Arrivals You'll Love" />
 </div>

 <style dangerouslySetInnerHTML={{
 __html: `
 @keyframes float {
 0% { transform: translateY(0px); }
 50% { transform: translateY(-15px); }
 100% { transform: translateY(0px); }
 }
 .animate-float { animation: float 4s ease-in-out infinite; }
 ` }} />
 </div>
 )
 }

 return (
 <div className='bg-[#f4f7f5] min-h-screen pb-20'>
 <div className='container mx-auto py-6 lg:py-10 px-4'>
 <div className='bg-white rounded-[40px] shadow-sm border border-gray-100 overflow-hidden mb-12'>
 <div className='bg-[#e8f5ed] px-8 py-8 flex items-center justify-between border-b border-green-50'>
 <div className='flex items-center gap-5'>
 <div className='bg-[#143d2c] p-4 rounded-3xl text-white shadow-lg shadow-green-100 rotate-3'>
 <FaHeart size={28} />
 </div>
 <div>
 <h1 className='text-3xl font-black text-[#143d2c] uppercase tracking-tighter'>My Wishlist</h1>
 <p className='text-[#2d8a5a] font-bold text-sm tracking-widest uppercase'>{wishlistItems.length} Loved {wishlistItems.length === 1 ? 'Product' : 'Products'}</p>
 </div>
 </div>
 <button onClick={() => navigate(-1)} className='p-3 hover:bg-white rounded-full transition-all text-gray-500'>
 <MdClose size={32} />
 </button>
 </div>

 <div className='p-6 lg:p-10'>
 <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8'>
 {wishlistItems.map((product) => {
 const cartItem = cartItems?.find(item =>
 (item.productId?._id === product?._id) || (item.productId === product?._id)
 )
 const isInCart = !!cartItem
 const quantity = cartItem?.quantity || 0
 const isDummy = cartItem?.isDummy || product?._id?.startsWith('dummy') || product?._id?.startsWith('f') || product?._id?.startsWith('h')
 const cartId = cartItem?._id
 const dummyId = cartItem?.dummyId || product?._id

 return (
 <div key={product._id} className='bg-white border border-gray-100 rounded-[36px] overflow-hidden hover:shadow-2xl transition-all duration-500 group relative flex flex-col h-full'>
 {/* Remove button */}
 <button
 className='absolute top-6 right-6 z-10 bg-white/80 backdrop-blur-md p-3 rounded-2xl text-gray-300 shadow-lg hover:text-red-500 transition-all scale-90 group-hover:scale-100'
 onClick={(e) => removeFromWishlist(e, product._id)}
 >
 <FaTrash size={18} />
 </button>

 <div className='h-64 bg-[#f8fcf9] p-8 flex items-center justify-center relative group-hover:bg-[#f0f9f2] transition-colors shrink-0'>
 <span className='absolute top-6 left-6 bg-[#00b259] px-3 py-1 rounded-full text-[10px] font-black text-white uppercase tracking-widest z-10'>{product.brandName || "Premium"}</span>
 <Link to={"/product/" + product?._id} className='w-full h-full'>
 <img
 src={product?.productImage[0]}
 className='w-full h-full object-contain mix-blend-multiply group-hover:scale-110 transition-transform duration-700'
 alt={product?.productName}
 />
 </Link>
 </div>

 <div className='p-8 flex flex-col flex-1'>
 <div className='flex flex-col gap-1 mb-4'>
 <div className='flex items-center gap-2'>
 <span className='text-[10px] font-black text-[#00b259] uppercase tracking-widest'>{product?.category}</span>
 <div className='h-1 w-1 bg-gray-200 rounded-full'></div>
 <span className='text-[10px] font-medium text-gray-400'>{product.unit || "1 Pack"}</span>
 </div>
 <Link to={"/product/" + product?._id} className='text-lg font-black text-[#143d2c] uppercase tracking-tight group-hover:text-[#00b259] transition-colors line-clamp-2 leading-tight h-12'>
 {product?.productName}
 </Link>
 </div>

 <div className='flex items-end gap-3 mb-6 mt-auto'>
 <span className='text-2xl font-black text-[#1a1a1a]'>{displayINRCurrency(product?.sellingPrice)}</span>
 {product?.price > product?.sellingPrice && (
 <span className='text-sm text-gray-300 line-through font-bold pb-1'>{displayINRCurrency(product?.price)}</span>
 )}
 </div>

 {/* Quantity / Add UI */}
 <div className='h-12'>
 {isInCart ? (
 <button
 className='w-full bg-[#143d2c] hover:bg-[#111] text-white font-black py-4 rounded-[20px] shadow-lg transition-all active:scale-95 text-[11px] uppercase tracking-[2px] flex items-center justify-center gap-3 h-full mb-0 border-2 border-[#00b259]'
 onClick={() => setShowCart(true)}
 >
 Go to Cart →
 </button>
 ) : (
 <button
 className='w-full bg-[#143d2c] hover:bg-[#00b259] text-white font-black py-4 rounded-[20px] shadow-lg transition-all active:scale-95 text-[11px] uppercase tracking-[2px] flex items-center justify-center gap-3 h-full mb-0'
 onClick={(e) => handleAddToCart(e, product._id)}
 >
 <FaShoppingBag /> Add to Cart
 </button>
 )}
 </div>
 </div>
 </div>
 )
 })}
 </div>
 </div>
 </div>

 <div className='mt-20'>
 <HorizontalCardProduct category="Crop Care" heading="Frequently Bought Together" />
 </div>
 </div>
 </div>
 )
}

export default Wishlist
